import { useMutation } from '@tanstack/react-query';
import { message } from 'antd';
import { useRouter } from 'next/router';
import { useTranslations } from 'next-intl';

import { useAppDispatch } from 'store';

import { setContinue } from 'modules/auth';
import { $api, errorHandler } from 'modules/global';

export const useBuyPremium = () => {
  const t = useTranslations();
  const { push } = useRouter();
  const dispatch = useAppDispatch();

  return useMutation({
    mutationFn: async (application: { type?: string | null; month_count?: string }) => {
      const { data } = await $api.post('/buy-premium', undefined, { params: application });

      return data;
    },
    onSuccess: data => {
      if (typeof data === 'string') {
        message.success(t('Muvaffaqiyatli_bajarildi'));
        window.open(data, '_blank');
      } else if (data === false) {
        push('/login');

        dispatch(setContinue());
      }
    },
    onError: errorHandler()
  });
};
